import type { StaticLayerPayload } from "@config";
import { SetLibrary } from "@library-layers/set";
import { Container } from "../Container";

export const Set = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={{ default: SetLibrary }} />
);
